




import Component, { mixins } from 'vue-class-component';
import { localizeNumber } from '../../config/translation/translation.config';
import AbstractAnimated from './abstract-animated.vue';

@Component({
  name: 'eq-web-animated-number',
})
export default class AnimatedNumber extends mixins(AbstractAnimated) {
  constructor() {
    super();
  }

  private get localizedValue(): string {
    return localizeNumber(this.displayValue);
  }
}
